import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './styles/brand-colors.css';
import './App.css';
import './styles/iframe-card-display.css';
import CardViewRequestPage from './pages/CardViewRequestPage';
import HomePage from './pages/HomePage';
import { useDirection } from './hooks/useDirection';
import './i18n';

function App() {
  // Automatically set HTML dir attribute based on current language
  useDirection();

  return (
    <Router
      basename="/card-view"
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/01234567890123456789012345678901" element={<CardViewRequestPage />} />
        <Route path="/card-view-request/:cvrt" element={<CardViewRequestPage />} />
        <Route path="/:cvrt" element={<CardViewRequestPage />} />
      </Routes>
    </Router>
  );
}

export default App;